import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { TemplateApiModel } from '../../../types/models/template.model';
import { SearchTemplatesApiRequest } from '../../../types/requests/templates/search-templates.request';
import { GetTemplateApiRequest } from '../../../types/requests/templates/get-template.request';
import { CreateTemplateApiRequest } from '../../../types/requests/templates/create-template.request';
import { UpdateTemplateApiRequest } from '../../../types/requests/templates/update-template.request';
import { ExportTemplateApiRequest } from '../../../types/requests/templates/export-template.request';
import { DeleteTemplateApiRequest } from '../../../types/requests/templates/delete-template.request';
import { SyncPlanApiModel } from '../../../types/models/sync/sync-plan.model';

export const createTemplate = (params: CreateTemplateApiRequest) => client.post<TemplateApiModel>('/templates', params);

export const updateTemplate = ({ templateId, ...params }: UpdateTemplateApiRequest) =>
  client.patch<TemplateApiModel>(`/templates/${templateId}`, params);

export const searchTemplates = <T extends TemplateApiModel>(params: SearchTemplatesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/templates`, { params });

export const getTemplate = <T extends TemplateApiModel>({ templateId, ...params }: GetTemplateApiRequest) =>
  client.get<T>(`/templates/${templateId}`, { params });

export const deleteTemplate = ({ templateId }: DeleteTemplateApiRequest) =>
  client.delete<void>(`/templates/${templateId}`);

export const uploadTemplate = (params: FormData) => client.post<SyncPlanApiModel>(`/sync/templates`, params);

export const exportTemplate = ({ templateId }: ExportTemplateApiRequest) =>
  client.get<string>(`/sync/templates/${templateId}`);
